export const rhytCardTypes: {
    [rhytName: string]: {
        time: number | number[],
        os: number,
        width?: number,
        rest?: boolean,
        scale?: number,
    }
} = {
    ta: {
        time: 1,
        os: 30,
    },
    tam: {
        time: 1.5,
        os: 30,
    },
    "ta-a": {
        time: 2,
        os: 30,
    },
    "ta-a-a": {
        time: 3,
        os: 30,
    },
    "ta-a-a-a": {
        time: 4,
        os: 30,
    },
    "ta-a-a-a-a-a": {
        time: 6,
        os: 30,
    },
    ti: {
        time: 0.5,
        os: 30,
    },
    titi: {
        time: [0.5, 0.5],
        os: 15,
    },
    timri: {
        time: [0.75, 0.25],
        os: 15,
    },
    ritim: {
        time: [0.25, 0.75],
        os: 15,
    },
    tiriri: {
        time: [0.5, 0.25, 0.25],
        os: 10,
        width: 1.1,
    },
    ririti: {
        time: [0.25, 0.25, 0.5],
        os: 12,
        width: 1.1,
    },
    riri: {
        time: [0.25, 0.25],
        os: 20,
        width: 0.65,
    },
    ri: {
        time: 0.25,
        os: 30,
        width: 0.5,
    },
    "rest-4d": {
        time: -1.5,
        rest: true,
        os: 35,
    },
    "rest-4": {
        time: -1,
        rest: true,
        os: 35,
    },
    "rest-2": {
        time: -2,
        rest: true,
        os: 35,
    },
    "rest-1": {
        time: -4,
        rest: true,
        os: 35,
    },
    "rest-8": {
        time: -0.5,
        rest: true,
        os: 35,
    },
    "rest-16": {
        time: -0.25,
        rest: true,
        os: 35,
        width: 0.3,
    },
    tititi: {
        time: [0.5, 0.5, 0.5],
        os: 0,
    },
    ririririti: {
        time: [0.25, 0.25, 0.25, 0.25, 0.5],
        os: 0,
    },
    tiriririri: {
        time: [0.5, 0.25, 0.25, 0.25, 0.25],
        os: 0,
        width: 1.65,
    },
    rirititi: {
        time: [0.25, 0.25, 0.5, 0.5],
        os: 0,
    },
    ritimti: {
        time: [0.25, 0.75, 0.5],
        os: 0,
    },
    timriti: {
        time: [0.75, 0.25, 0.5],
        os: 0,
    },
    titiriri: {
        time: [0.5, 0.5, 0.25, 0.25],
        os: -5,
        width: 1.6,
    },
    riririri: {
        time: [0.25, 0.25, 0.25, 0.25],
        os: 5,
        width: 1.25,
    },
    truplet: {
        time: [0.34, 0.33, 0.33],
        os: 0,
        width: 1.25,
    },
    titititi: {
        time: [0.5, 0.5, 0.5, 0.5],
        os: 0,
        scale: 1.3,
    },
};
